module.exports = __webpack_public_path__ + "static/Unify-1-dark-b9c471215b3f39e8c0e4d27d18921d21.svg";